import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PartnerStatusFilter } from '../../admin/admin-partners/partner-status-filter.enum';
import { PartnerType } from '../../admin/admin-partners/partner-type.enum';
import * as fromPartnersList from './partners-list.reducer';

export const selectPartnersListState = createFeatureSelector<fromPartnersList.HubPartnersListState>(
  fromPartnersList.featureKey
);

export const getPartnersType = createSelector(selectPartnersListState, state => state.partnerType);

export const getPartnersStatus = createSelector(selectPartnersListState, state => state.status);

export const getPartnersList = createSelector(
  selectPartnersListState,
  state => state?.partners);

export const getPartnersByStatus = createSelector(
  selectPartnersListState,
  state => {
    if (state.partnerType === PartnerType.AIRLINE) {
      return state?.partners;
    }

    if (state.status === PartnerStatusFilter.ACTIVE) {
      return state?.partners?.filter(partner => partner.enabled);
    }

    if (state.status === PartnerStatusFilter.INACTIVE) {
      return state?.partners?.filter(partner => !partner.enabled);
    }

    return state?.partners;
  });

